// extracted by mini-css-extract-plugin
export var address = "AddressOption_address__Vq47l";
export var container = "AddressOption_container__5bFxt";
export var selected = "AddressOption_selected__gTfq5";
export var suggested = "AddressOption_suggested__-JBZH";
export var title = "AddressOption_title__VVjL1";